import React from "react";
import "./InfosBulle.scss";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

function InfosBulle({
  text,
  up,
  position,
  start = false,
  textPosition,
  alignRight = false,
  alignLeft = false,
}) {
  const arrowLeftInWrapper = Math.max(4, position - textPosition - 6);
  let wrapperStyle;
  let arrowStyle;
  if (alignRight) {
    wrapperStyle = { right: "8px", left: "auto" };
    arrowStyle = { right: "8px", left: "auto" };
  } else if (alignLeft) {
    wrapperStyle = { left: "8px", right: "auto" };
    arrowStyle = { left: "8px", right: "auto" };
  } else {
    wrapperStyle = { left: `${textPosition}px` };
    arrowStyle = { left: `${arrowLeftInWrapper}px` };
  }
  return (
    <div
      className={`infos-wrapper ${up ? "infos-up" : "infos-down"}`}
      style={wrapperStyle}
    >
      <div className="infos-bulle">
        <p className="infos-bulle-text">
          <FormattedMessage
            id={
              start ? "mission_start_dashboard" : "mission_end_order_dashboard"
            }
            defaultMessage={text}
          />{" "}
          {text}
        </p>
      </div>
      <div
        className={up ? "infos-arrow-up" : "infos-arrow-down"}
        style={arrowStyle}
      ></div>
    </div>
  );
}

export default InfosBulle;

InfosBulle.propTypes = {
  text: PropTypes.string,
  up: PropTypes.bool,
  position: PropTypes.number,
  start: PropTypes.bool,
  textPosition: PropTypes.number,
  alignRight: PropTypes.bool,
  alignLeft: PropTypes.bool,
};
